const showNavbar = open => dispatch => {
  dispatch({
    type: "SHOW_NAVBAR",
    payload: open,
  });
};

export default showNavbar;
